import React, {
  CSSProperties,
  PropsWithChildren,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import LoadingPage from './LoadingPage';
import Visible from './Visible';
import { TYPE_LOADING_ENUM } from '../../applications/constants/AppConst';

interface ScaffoldProps extends PropsWithChildren {
  isLoading: boolean;
  typeLoading?: TYPE_LOADING_ENUM;
  customStyle?: CSSProperties;
}

const Scaffold: React.FC<ScaffoldProps> = (props) => {
  const {
    children,
    isLoading,
    typeLoading = TYPE_LOADING_ENUM.OVERLAY,
    customStyle = {
      height: '100%',
    },
  } = props;

  const childRef = useRef<HTMLDivElement>(null);

  const [heightContent, setHeightContent] = useState(0);

  useLayoutEffect(() => {
    const valueHeight = childRef?.current?.clientHeight || 0;
    if (valueHeight > 0) {
      setHeightContent(valueHeight);
    }
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        height: '100%',
      }}
    >
      <div
        style={{
          opacity:
            typeLoading === TYPE_LOADING_ENUM.REPLACE ? (isLoading ? 0 : 1) : 1,
          height: '100%',
        }}
        ref={childRef}
      >
        {children}
      </div>

      <Visible isVisible={isLoading}>
        {heightContent > 0 && (
          <LoadingPage
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              background:
                typeLoading === TYPE_LOADING_ENUM.REPLACE
                  ? undefined
                  : 'rgba(0,0,0,0.3)',
              zIndex: 1000,
              height: heightContent,
              ...customStyle,
            }}
          />
        )}
      </Visible>
    </div>
  );
};
export default Scaffold;
